import { render, staticRenderFns } from "./store-locator-wishlist.vue?vue&type=template&id=0949c373"
import script from "./store-locator-wishlist.vue?vue&type=script&lang=js"
export * from "./store-locator-wishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports